import { ApiService } from './api.service';
import { UserResponseModel } from '../core/domain/User/User.type';

export const UserApi = {
	getCurrentUser() {
		return ApiService.get<UserResponseModel>('/user/current');
	},
};
